import { Css } from "@homebound/beam";
import { useRouteParams } from "src/hooks/useRouteParams";
import { usePlanPackageTakeoffPageQuery } from "src/routes/libraries/plan-package/takeoffs/PlanPackageTakeoffPage.generated";
import { PlanPackageTakeoffSideBar } from "src/routes/libraries/plan-package/takeoffs/PlanPackageTakeoffSideBar";
import { TakeoffsManagerProvider } from "src/routes/libraries/plan-package/takeoffs/TakeoffsManagerContext";
import { PlanPackageTakeoffParams } from "src/routes/routesDef";
import { SideNavLayoutRoute } from "src/routing/components/layouts/SideNavLayoutRoute";
import { queryResult } from "src/utils";

/**
 * Plan package takeoffs SideNav chrome for the data router.
 *
 * Role: data router pathless layout. Owns takeoff query + `TakeoffsManagerProvider` so the
 * sidebar and page outlet share store state, then renders legacy `SideNavLayout` via
 * `SideNavLayoutRoute`.
 */
export function PlanPackageTakeoffSideNavLayout() {
  const { planPackageId, planPackageVersionId: rpavId } = useRouteParams<PlanPackageTakeoffParams>();
  const query = usePlanPackageTakeoffPageQuery({ variables: { planPackageId, rpavId } });

  return queryResult(query, (data) => (
    <TakeoffsManagerProvider planPackage={data.planPackage}>
      <SideNavLayoutRoute
        sideNavProps={{ sideNavConfig: [], top: <PlanPackageTakeoffSideBar />, navWidth: 265 }}
        layoutProps={{ contentCss: Css.pb3.mr2.$ }}
      />
    </TakeoffsManagerProvider>
  ));
}
